<template>
<div class="position-relative header mh-50vh d-flex align-items-center overflow-hidden">
  <div class="position-absolute-center w-100 h-100 bg-cover-center inview_animate_zoom" :style="{'background-image': headerImage }"></div>
  <div class="layer position-absolute w-100 h-100"></div>
  <div class="container-fluid">
    <div class="row my-4 justify-content-center">
      <div class="col-md-10 row mx-0 px-0 text-white">
        <div class="col-12 col-md-6">
          <text-section :content="content"></text-section>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import TextSection from "text-section";

export default {
  mixins: [fandomBasicMixin],
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  components: {
    TextSection
  },
  mounted() {
    Vue.nextTick(() => {
      this.registerAnimation();
    });
  },
  computed: {
    headerImage() {
      return this.content.image ? Fandom.getBackgroundUrl(this.content.image.url) : 'none';
    },
    title() {
      if (this.content.title) {
        return this.content.title;
      }
      if (globalState.pageModel.seo && globalState.pageModel.seo.title) {
        return globalState.pageModel.seo.title.split('|')[0];
      } else {
        const mainContentName = globalState.pageModel.main_content_name;
        return globalState.pageModel.name_to_content[mainContentName].title;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>